import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { isEmpty, validateEmail } from '../../utils/utils';
import { trans } from '../../localization/index';
import './login.scss';
import { forgetPassword } from '../../authentication/actions';

import EmailIcon from '../../assets/common/images/icon/email.png'

class ForgotPassword extends React.Component {
  state = {
    email: '',
    errorMessage: '',
    successMessage: '',
  };

  onChangeEmail = (event) => {
    this.setState({
      email: event.target.value,
      errorMessage: '',
      successMessage: '',
    });
  };

  sendEmail = () => {
    const { email } = this.state;
    if (isEmpty(email)) {
      this.setState({ errorMessage: trans('please_input_email') });
    } else if (!validateEmail(email)) {
      this.setState({ errorMessage: trans('email_format_is_incorrect') });
    } else {
      const { forgetPasswordConnect } = this.props;
      const successCallback = () => {
        this.setState({
          successMessage: trans('note_forget_password_success'),
        });
      };
      const failureCallback = (errorMessage) => {
        this.setState({
          errorMessage,
        });
      };
      forgetPasswordConnect(email, successCallback, failureCallback);
    }
  };

  render() {
    const { email, errorMessage, successMessage } = this.state;
    return (
      <div className="now-login">
        <div className="content w-420">
          <div className="title">Quên mật khẩu</div>
          <p>Điền email đăng ký của bạn, ShopeeFood sẽ gửi cho bạn mật khẩu mới.</p>
          <div className="form-login-input">
            <div className="field-group">
              <div className="input-group">
                <img className="far fa-envelope" src={EmailIcon} alt="email icon" />
                {/* <i className="far fa-envelope" /> */}
                <input
                  type="text"
                  placeholder="Email"
                  value={email}
                  onChange={this.onChangeEmail}
                />
              </div>
            </div>
            {errorMessage && <div className="alert-danger">{errorMessage}</div>}
            {successMessage && (
              <div className="alert-success">{successMessage}</div>
            )}
            <button className="btn" onClick={this.sendEmail}>
              Gửi lại mật khẩu
            </button>
            <div className="link">
              <Link to="/account/login">{trans('account_login')}</Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  forgetPasswordConnect: (email, sucessCallback, failureCallback) => {
    dispatch(forgetPassword(email, sucessCallback, failureCallback));
  },
});

export default connect(
  null,
  mapDispatchToProps,
)(ForgotPassword);



// WEBPACK FOOTER //
// ./foody/src/pages/Login/ForgotPassword.jsx